import React from "react";
import "./SoleraLoader.css";
import GLogo from "./GLogo";

const BasicLoader = () => {
  return (
    <div className="logo logo--basic">
      <GLogo />
    </div>
  );
};

export default BasicLoader;
